export const removeClass = (element: HTMLElement, className: string | string[]) => {
  const classList = element.classList;

  typeof className === 'string'
    ? classList.remove(className)
    : className.forEach(name => classList.remove(name));
};
